import { useMemo } from 'react';
import { useDispatch } from 'src/store';
import { actions } from 'src/store/navbar';

export const useCuisineFilterButtonActions = () => {
  const dispatch = useDispatch();

  return useMemo(
    () => ({
      show: () => {
        dispatch(actions.showCuisineFilterButton());
      },
      hide: () => {
        dispatch(actions.hideCuisineFilterButton());
      },
      dockOnDesktop: () => {
        dispatch(actions.dockCuisineFilterButtonDesktop());
      },
      dockOnTablet: () => {
        dispatch(actions.dockCuisineFilterButtonTablet());
      },
      dockOnMobile: () => {
        dispatch(actions.dockCuisineFilterButtonMobile());
      },
      undockOnDesktop: () => {
        dispatch(actions.undockCuisineFilterButtonDesktop());
      },
      undockOnTablet: () => {
        dispatch(actions.undockCuisineFilterButtonTablet());
      },
      undockOnMobile: () => {
        dispatch(actions.undockCuisineFilterButtonMobile());
      },
    }),
    [dispatch]
  );
};
